import { Component, OnInit, Input } from '@angular/core';
import { faPlus, faTrashAlt, faHistory, faEdit } from '@fortawesome/pro-light-svg-icons';
import { CaseService } from '../../../shared/services/case.service';
import { AuthService } from '../../../auth/auth.service';
import { Subscription } from 'rxjs';
import { AddCaseNotesComponent } from './add-case-notes/add-case-notes.component';
import { CaseNotesHistoryComponent } from './case-notes-history/case-notes-history.component';
import { CorrespondenceTimelineService } from '../../../shared/services/correspondence-timeline.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-case-notes',
  templateUrl: './case-notes.component.html',
  styleUrls: ['./case-notes.component.scss']
})
export class CaseNotesComponent implements OnInit {

  notes: any;
  viewInit = false;
  _caseId?: (number | undefined);

  @Input()
  set caseId(value: (number | undefined)) {
    this._caseId = value;
    this.loadCaseNotes();
  }
  get caseId() : (number | undefined)  {
    return this._caseId;
  }

  @Input() readOnly = true;
  @Input() caseInstructed = true;

  faPlus = faPlus;
  faTrashAlt = faTrashAlt;
  faHistory = faHistory;
  faEdit= faEdit;

  notesLoaded: boolean = false;

  refreshSubscription: Subscription;

  constructor(
              private caseService: CaseService,
              public authService: AuthService,
              private correspondenceTimelineService: CorrespondenceTimelineService,
             public modalService: ModalService,
             public activeModal: NgbActiveModal ) {

      this.refreshSubscription = this.caseService.refreshCaseNotesObservable.subscribe(() => {
        this.loadCaseNotes();
      });
    }

  ngOnInit(): void {
  }

  ngAfterContentInit() : void {
    this.viewInit = true;
    this.loadCaseNotes();
  }

  loadCaseNotes(){

    if (!this.viewInit) return;

    this.caseService.getCaseNotes(this.caseId).subscribe(result => {
      this.notes = result;
      this.notesLoaded = true;
    }, error => {

      var errorMessage = "Failed to get notes";
      if (error.error !== null && error.error.message !== undefined) {
        errorMessage = error.error.message;
      }

    });
  }

  addCaseNotes(){

     const modalRef = this.modalService.openWithOptions(AddCaseNotesComponent, { size: 'lg'});
    
     modalRef.componentInstance.caseId = this.caseId;

      modalRef.result.then(
        (result) => {
          if (result === true) {
           this.loadCaseNotes();
          }
        },
        () => {
        }
      );

  }

  deleteNote(noteId : number){

     const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, {size: 'lg'});
          
      modalRef.componentInstance.messageHeader = 'Are you sure you want to delete this note?';
      modalRef.componentInstance.popupText1 = '';
      modalRef.componentInstance.popupText2 = '';

      modalRef.result.then(
        (result) => {

          if(result)
          {
              this.caseService.deleteCaseNote(this.caseId, noteId).subscribe(result => {
                    this.loadCaseNotes();
                    this.correspondenceTimelineService.refreshCaseTimeline.next();
            });
          }

      },
      () => {} // dismissed - do nothing
    );

  }

  editNote(noteId : number){

     const modalRef = this.modalService.openWithOptions(AddCaseNotesComponent, { size: 'lg'});
    
     modalRef.componentInstance.caseId = this.caseId;
     modalRef.componentInstance.caseNoteId = noteId;

      modalRef.result.then(
        (result) => {
          if (result === true) {
           this.loadCaseNotes();
          }
        },
        () => {
        }
      );
  }

  viewHistory(){

    const modalRef = this.modalService.openWithOptions(CaseNotesHistoryComponent, { size: 'xl'});
    
     modalRef.componentInstance.caseId = this.caseId;

      modalRef.result.then(
        (result) => {
          if (result === true) {
           this.loadCaseNotes();
          }
        },
        () => {
        }
      );

  }

  ngOnDestroy(){
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }
}
